<template>
    <nav>
      <v-row class="w-100 align-center loginBackground justify-center">
        <v-alert
          v-if="alertMsg != ''"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
          min-width="300"
        >
          {{ $t(alertMsg) }}
        </v-alert>
      </v-row>
      <v-row class="fill-height loginBackground" align="center">
        <v-col
          cols="12"
          sm="8"
          md="6"
          offset-sm="2"
          offset-md="3"
          align="center"
        >
          <v-progress-circular
            v-if="!success"
            :size="125"
            :width="7"
            indeterminate
            class="my-16"
            color="accent"
          />
  
          <v-icon
            v-if="success"
            color="success"
            size="x-large"
            style="font-size: 128px"
            >mdi-checkbox-marked-circle-outline</v-icon
          >
        </v-col>
      </v-row>
    </nav>
  </template>
  <script>
  import i18n from '../../plugins/i18n'
  import { setVismaAuthToken } from "../../api/vismaApi";
  
  export default {
    components: {},
    data() {
      return {
        alertType: "",
        alertMsg: "",
        vismaCallback: false,
        loadingData: false,
        success: false,
      };
    },
  
    async created() {
      this.loadingData = true;
  
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
     
      let vismaAuthCode = urlParams.get("code");
      if (vismaAuthCode) {
        this.vismaCallback = true;
        await this.setVismaAuthToken(vismaAuthCode);
      } else {
        this.vismaCallback = false;
        this.alertType = "error";
        this.alertMsg = "Invalid or missing Authorization Code";
      }
      this.loadingData = false;
    },
  
    methods: {
      async setVismaAuthToken(vismaAuthCode) {
        if (window.$cookies.get("vismaId")) {
          var integrationId = window.$cookies.get("vismaId");
  
          try {
            const response = await setVismaAuthToken(
              integrationId,
              vismaAuthCode
            );
            if (response.status == 200) {
              if (response.data.meta.status == "success") {
                this.success = true;
                setTimeout(() => {
                  window.close();
                }, 3000);
              }
            }
          } catch (e) {
            if (e.response) {
              this.vismaCallback = false;
              this.alertType = "error";
              this.alertMsg = e.response.data.errors[0].detail;
            }
          }
        } else {
          this.vismaCallback = false;
          this.alertType = "error";
          this.alertMsg = i18n.t("invalidIntegration")
        }
      },
    },
  };
  </script>
  